export type TemplateSource = 'SYSTEM' | 'CUSTOM';
export type TemplateCategory =
  | 'distribution'
  | 'drawdown'
  | 'report'
  | 'notice'
  | 'other';

export type EmailTemplateCategory =
  | 'drawdown_notification'
  | 'distribution_notification'
  | 'report_notification'
  | 'general';

export const AVAILABLE_VARIABLES = [
  'fund.name',
  'fund.base_currency',
  'fund.bank_name',
  'fund.bank_iban',
  'fund.bank_swift',
  'distribution.distribution_number',
  'distribution.distribution_date',
  'distribution.description',
  'investor.name',
  'allocation.amount',
  'allocation.return_of_capital',
  'allocation.preferred_return',
  'allocation.catch_up',
  'allocation.carried_interest_lp',
  'allocation.carried_interest_gp',
  'fund_relationship.commitment_amount',
  'fund_relationship.total_distributed',
  'organization.display_name',
  'organization.email',
  'organization.phone',
  'organization.address_line1',
  'organization.address_line2',
  'organization.city',
  'organization.postal_code',
  'organization.country',
];

export const CATEGORY_LABELS: Record<TemplateCategory, string> = {
  distribution: 'Distribution',
  drawdown: 'Drawdown',
  report: 'Report',
  notice: 'Notice',
  other: 'Other',
};

export const EMAIL_CATEGORY_LABELS: Record<EmailTemplateCategory, string> = {
  drawdown_notification: 'Drawdown',
  distribution_notification: 'Distribution',
  report_notification: 'Report',
  general: 'General',
};

export const DOC_PAGE_SIZE = 10;
export const EMAIL_PAGE_SIZE = 10;

export function getCategoryBadgeColor(category: string): string {
  switch (category) {
    case 'drawdown':
    case 'drawdown_notification':
      return 'bg-blue-100 text-blue-800';
    case 'distribution':
    case 'distribution_notification':
      return 'bg-green-100 text-green-800';
    case 'report':
    case 'report_notification':
      return 'bg-purple-100 text-purple-800';
    case 'notice':
      return 'bg-amber-100 text-amber-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
}
